import React from 'react';
import Spinner from '@salesforce/design-system-react/components/spinner';

export default function Index({ size = 'large', variant = 'base', loadingMsg }) {
  return (
    <div style={{ position: 'relative', height: '100vh' }}>
      <Spinner
        size={size}
        variant={variant}
        assistiveText={{ label: loadingMsg || ' "Loading..."' }}
      />
    </div>
  );
}
